var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _g, _g2, _path, _path2, _path3, _g3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgfilter3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 142.29,
  height: 85.56,
  x: 67,
  y: 39.44,
  fill: "#fff",
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 57,
  x: 81,
  y: 53,
  fill: "#F4F4F4",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 7,
  x: 143,
  y: 53,
  fill: "#F4F4F4",
  rx: 3.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 7,
  x: 143,
  y: 66,
  fill: "#F4F4F4",
  rx: 3.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 7,
  x: 143,
  y: 79,
  fill: "#F4F4F4",
  rx: 3.5
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 78.471,
  height: 46,
  x: 49,
  y: 15,
  fill: "#008060",
  rx: 2
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 58.05,
  y: 23.156,
  fill: "#fff",
  rx: 1
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 58.05,
  y: 39.102,
  fill: "#66B3A0",
  rx: 1
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 17.066,
  height: 12.756,
  x: 79.382,
  y: 23.156,
  fill: "#66B3A0",
  rx: 1
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 17.066,
  height: 12.756,
  x: 79.382,
  y: 39.102,
  fill: "#66B3A0",
  rx: 1
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 99.292,
  y: 23.156,
  fill: "#66B3A0",
  rx: 1
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 18.488,
  height: 12.756,
  x: 99.292,
  y: 39.102,
  fill: "#66B3A0",
  rx: 1
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 93,
  height: 52,
  x: 171,
  y: 25,
  fill: "#fff",
  rx: 2
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 32.222,
  height: 6.444,
  x: 177.444,
  y: 29.832,
  fill: "#008060",
  rx: 3.222
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 5,
  x: 177,
  y: 41,
  fill: "#008060",
  opacity: 0.4,
  rx: 2.5
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 5,
  x: 177,
  y: 49,
  fill: "#008060",
  opacity: 0.4,
  rx: 2.5
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 5,
  x: 177,
  y: 57,
  fill: "#008060",
  opacity: 0.4,
  rx: 2.5
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 5,
  x: 177,
  y: 65,
  fill: "#008060",
  opacity: 0.4,
  rx: 2.5
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 70.429,
  height: 34,
  x: 32,
  y: 77,
  fill: "#fff",
  rx: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#99CCBF",
  clipPath: "url(#img_filter3_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 44.5,
  cy: 87.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.129,
  cy: 87.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67.758,
  cy: 87.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79.387,
  cy: 87.934,
  r: 4,
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.016,
  cy: 87.934,
  r: 4,
  opacity: 0.8
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#99CCBF",
  clipPath: "url(#img_filter3_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 44.5,
  cy: 100.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56.129,
  cy: 100.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67.758,
  cy: 100.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79.387,
  cy: 100.895,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91.016,
  cy: 100.895,
  r: 4
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M153 102a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v17.976a2 2 0 0 1-2 2h-92a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M188 111h49"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4.503,
  d: "M164.566 110.684h24.506",
  opacity: 0.4
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img_filter3_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 189.072,
  cy: 110.684,
  r: 4.901,
  fill: "#66B3A0"
}))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 189.073,
  cy: 110.684,
  r: 3.676,
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40.5 83.072h54.516v9.721H40.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_filter3_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40.5 96.033h54.516v9.721H40.5z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img_filter3_svg__c",
  width: 15.206,
  height: 15.207,
  x: 182.37,
  y: 103.982,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.901,
  dy: 0.901
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.351
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.501961 0 0 0 0 0.376471 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9997_6852"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9997_6852",
  result: "shape"
})))));
export { SvgImgfilter3 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.filter3.177d2a36.svg";